<template>
    <portal :to="`tab-${tabId}`">
        <TabFooter>
            <div class="form-submit-sticky-container">
                <div class="form-content">
                    <div class="span-all">
                        <ButtonGroup
                            v-if="submitContent || cancelContent || $slots?.actions"
                            :align="actionsAlign"
                            margin="none"
                        >
                            <slot name="other-fields" />
                            <Button
                                :disabled="disableSubmit"
                                name="submit"
                                type="submit"
                                :size="submitSize"
                                :variant="submitVariant"
                                :icon-path="!operationsanmalanId ? SendIconWhite : ''"
                                @click="onSubmit"
                            >
                                {{ submitContent }}
                            </Button>
                            <slot name="actions" />
                            <Button
                                v-if="cancelContent"
                                name="cancel"
                                type="button"
                                :size="cancelSize"
                                :variant="cancelVariant"
                                @click="callOnCancel"
                            >
                                {{ cancelContent }}
                            </Button>
                        </ButtonGroup>
                    </div>
                </div>
            </div>
        </TabFooter>
    </portal>
</template>

<script setup lang="ts">
    import Button from "@/components/Button.vue";
    import ButtonGroup from "@/components/ButtonGroup.vue";
    import TabFooter from "@/tabs/TabFooter.vue";
    import { defineEmits } from "vue";
    import SendIconWhite from "@/assets/send_white.svg";

    const emit = defineEmits<{
        (e: "update:anmalanStatus", value: string | { value: string }): void;
        (e: "submit", value: typeof props.formRef): void;
    }>();

    const props = withDefaults(
        defineProps<{
            formRef?: any;
            formId: string;
            tabId: number;
            submitContent?: string;
            cancelContent?: string;
            disableSubmit?: boolean;
            submitSize?: string;
            cancelSize?: string;
            submitVariant?: string;
            cancelVariant?: string;
            operationsanmalanId?: string;

            /**
             * Alignment på actionknapparna. Används om en custom template skickats in för actions
             */
            actionsAlign?: "left" | "center" | "right";
        }>(),
        {
            submitContent: "",
            cancelContent: "",
            disableSubmit: false,
            submitSize: "primary",
            submitVariant: "standard",
            cancelVariant: "contour",
            cancelSize: "secondary",
            actionsAlign: undefined,
            operationsanmalanId: undefined,
        }
    );

    const onSubmit = async () => {
        const formData = await props.formRef?.manualSubmit();

        if (!formData) {
            return;
        }
        emit("submit", formData);
    };
    /**
     * on cancel
     */
    const callOnCancel = (event: Event) => {
        props.formRef?.onCancel(event);
    };
</script>

<style lang="scss" scoped>
    @use "@/components/forms/Form/styles/FormContent";
    @import "@/style/_variables.scss";
    @import "@/style/container.scss";

    .form-submit-sticky-container {
        @include FormContent.content;
    }
</style>
